import React from "react";

import ImageSliderOptions from "./ImageSliderOptions";
import ImagesSliderOptions from "./ImagesSliderOptions";
import { useImageSliderStore } from "../../../../../../stores/use-image-slider-store";

const ImageSliderSettings = () => {
  const image = useImageSliderStore((state) => state.image);

  const ImageSliderSettingsComponent = image
    ? ImageSliderOptions
    : ImagesSliderOptions;

  return <ImageSliderSettingsComponent />;
};

export default ImageSliderSettings;
